import 'react';
import { formatCurrency } from '@atc/string-fns';
import { Text } from 'reaxl';
import DigitalRetailOverlayCTA from '../DigitalRetailOverlayCTA/DigitalRetailOverlayCTA.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
const pipe = /*#__PURE__*/jsx("span", {
  className: "padding-horizontal-2",
  children: "|"
});
function Wrapper(_ref) {
  let {
    children
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    className: "margin-bottom-2 margin-top-4",
    children: children
  });
}
function DealCardVehicleProtection(_ref2) {
  let {
    dealData,
    component: Component,
    ...rest
  } = _ref2;
  if (typeof Component === 'undefined') {
    Component = Wrapper;
  }
  const {
    vehicle,
    vehicleProtection = {}
  } = dealData;
  const {
    vehicleProtectionProgram
  } = vehicle;
  const {
    products,
    VPPSelectedFlag
  } = vehicleProtection;
  const hasVehicleProtection = VPPSelectedFlag && products?.length > 0;
  const linkProps = {
    ...rest,
    ...dealData,
    listing: dealData.vehicle,
    listedPrice: dealData.vehicle.sellingPrice,
    route: 'protectionList',
    uiContext: 'dealPanel'
  };
  if (!vehicleProtectionProgram) {
    return null;
  }
  return /*#__PURE__*/jsxs(Component, {
    children: [/*#__PURE__*/jsx(Text, {
      weight: "bold",
      className: "display-block",
      children: "Additional Protections"
    }), hasVehicleProtection ? /*#__PURE__*/jsxs(Fragment, {
      children: [products?.map((item, index) => /*#__PURE__*/jsxs("div", {
        className: "display-flex justify-content-between",
        children: [/*#__PURE__*/jsx(Text, {
          children: item.name
        }), /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx(Text, {
            children: formatCurrency(item.price)
          }), item.monthly && /*#__PURE__*/jsxs(Fragment, {
            children: [pipe, /*#__PURE__*/jsxs(Text, {
              children: [formatCurrency(item.monthly), "/mo."]
            })]
          })]
        })]
      }, index)), /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
          ...linkProps,
          buttonText: "Edit vehicle protections"
        })
      })]
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(Text, {
        children: "We offer a wide variety of coverage and extras to keep money in your pocket and your car on the road."
      }), /*#__PURE__*/jsx("div", {
        "data-cmp": "deal-vehicleProtections",
        children: /*#__PURE__*/jsx(DigitalRetailOverlayCTA, {
          ...linkProps,
          buttonText: "Add vehicle protections"
        })
      })]
    })]
  });
}
export { DealCardVehicleProtection as default };
